import * as React from "react"
import { AboutDetails, AboutWrapper } from "./style"
import { graphql, useStaticQuery } from "gatsby"
import { FlexAlignCenter } from "./style"
import FloatingIceberg from "./Iceberg"

interface AboutProps {}

const About: React.FunctionComponent<AboutProps> = props => {
  const Data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
          about
        }
      }
    }
  `)

  return (
    <AboutWrapper>
      <FlexAlignCenter>
        <AboutDetails>
          <h1>Hi!</h1>
          <p>I'm Adam.</p>
          <p>
            Chemist who during his last year of the course felt passionate about
            python and programming. This is how my journey has started.
            Currently I am trying to combine my quality and perfectionist view
            with coding. I have a good eye for user experience, requirements,
            overall architecture and development priorities.
          </p>
          <p>
            In my free time I like to share here my knowledge and ideas. Ideas
            constantly keep me going. Most of them are 'too big to succeed' but
            I'm trying anyway!
          </p>
          <p>
            Some of my passions: books, books crossing, humanity, Buckminster's
            domes, Polaroid, unicycles.
          </p>
          <p>My goal is to help humanity and to have fun at the same time.</p>
        </AboutDetails>
        <FloatingIceberg />
      </FlexAlignCenter>
    </AboutWrapper>
  )
}

export default About
